/** Temas visuales del gimnasio (sitio + panel admin). */

export const DEFAULT_THEME_ID = "crimson-knockout";

export const GYM_THEMES = [
  { id: "crimson-knockout", name: "Box", hint: "Rojo ring y oro — clásico de boxeo" },
  { id: "sport-octagon", name: "Octágono", hint: "Naranja intenso — MMA y artes marciales" },
  { id: "sport-champion", name: "Campeón", hint: "Oro y bronce — podio y victoria" },
  { id: "sport-track", name: "Pista", hint: "Verde lima — atletismo y cardio" },
  { id: "sport-court", name: "Cancha", hint: "Naranja y azul — baloncesto y equipos" },
];

const VALID_THEME_IDS = new Set(GYM_THEMES.map((t) => t.id));

const LEGACY_THEME_IDS = new Set([
  "neon-venom",
  "toxic-sun",
  "electric-storm",
  "purple-rage",
  "lava-core",
  "ice-burst",
  "cyber-punch",
]);

export function resolveThemeId(theme) {
  if (theme && VALID_THEME_IDS.has(theme)) return theme;
  if (theme && LEGACY_THEME_IDS.has(theme)) return DEFAULT_THEME_ID;
  return DEFAULT_THEME_ID;
}

export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const id = typeof theme === "string" ? theme : theme?.theme;
  document.body.setAttribute("data-theme", resolveThemeId(id));
}
